/**
 * Risolve l'etichetta di un campo dinamico (o di una sua opzione) nella
 * lingua preferita, con fallback alla lingua di default del progetto e,
 * in ultima istanza, alla prima etichetta disponibile — un campo può non
 * avere tutte le lingue del progetto compilate.
 */
export function resolveLabel(labels, preferredLocale, fallbackLocale) {
  if (!labels) return '';
  if (preferredLocale && labels[preferredLocale]) return labels[preferredLocale];
  // Variante regionale senza etichetta propria (en-US): vale quella della stessa lingua (en-GB).
  const sibling = preferredLocale && Object.keys(labels).find((key) => key.slice(0, 2) === preferredLocale.slice(0, 2) && labels[key]);
  if (sibling) return labels[sibling];
  if (fallbackLocale && labels[fallbackLocale]) return labels[fallbackLocale];
  const values = Object.values(labels).filter(Boolean);
  return values[0] || '';
}

export function resolveFieldLabel(field, preferredLocale, fallbackLocale) {
  return resolveLabel(field?.labels, preferredLocale, fallbackLocale);
}
